/** Esqueleto del catálogo de servicios (grid de cards). */
export function ServiceCatalogSkeleton() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="h-44 animate-pulse rounded-card bg-surface" />
      ))}
    </div>
  )
}

/** Esqueleto del tab "Servicios activos" de un negocio (lista de paquetes contratados). */
export function BusinessServicesTabSkeleton() {
  return (
    <div className="space-y-2">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="h-14 animate-pulse rounded-card bg-surface" />
      ))}
    </div>
  )
}
